import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  standalone: false,
  selector: 'app-categories-detail',
  templateUrl: './categories-detail.component.html',
})
export class CategoriesDetailComponent implements OnInit {
  id = '';
  isEditMode = false;
  validationTriggered = false;
  item: any = null;
  form: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') ?? '';
    this.load();
  }

  load(): void {
    this.categoryService.get(this.id).subscribe({
      next: (result) => {
        this.item = result?.data ?? null;
        this.resetForm();
        this.isEditMode = false;
        this.validationTriggered = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.toaster.error('Category not found.');
        this.router.navigate(['/ecomm/categories']);
      },
    });
  }

  resetForm(): void {
    this.form = {
      name: this.item.name,
      status: this.item.status,
    };
  }

  startEdit(): void {
    this.resetForm();
    this.isEditMode = true;
    this.validationTriggered = false;
  }

  cancelEdit(): void {
    this.resetForm();
    this.isEditMode = false;
    this.validationTriggered = false;
  }

  save(): void {
    this.validationTriggered = true;
    if (!this.form.name) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    this.categoryService.update(this.id, {
      name: this.form.name,
      status: Number(this.form.status),
    }).subscribe({
      next: (result) => {
        this.item = result.data;
        this.isEditMode = false;
        this.validationTriggered = false;
        this.toaster.success('Category updated.');
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to update category.');
      },
    });
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }
}
